module.exports = __webpack_public_path__ + "img/sport.f122ce98.svg";